import _ from 'lodash';
// import { getSessionStorage } from '@utils';
import { getSessionStorage } from '@utils/windowUtil';

const routerProps = {
  match: null,
  location: null,
  history: null,
};

function initRouter(props) {
  if (props && !routerProps.history) {
    _.each(props, (value, name) => {
      routerProps[name] = value;
    });
  }
}

function naviTo(path) {
  const { history } = routerProps;

  if (history) {
    history.push(path);
  } else {
    throw new Error('No history object');
  }
}

function checkLogin(path = '/app') {
  const isLogin = window.localStorage.getItem('isLogin');

  if (isLogin) {
    naviTo(path);
  }
}

function handleNameInitialsModuleBack(history, systemSettingSection) {
  let systemSettingsFrom = getSessionStorage('systemSettingsFrom');
  systemSettingsFrom = systemSettingsFrom
    ? JSON.parse(systemSettingsFrom)
    : systemSettingsFrom;
  const previousRoute = systemSettingsFrom || history.location.state?.from;

  if (systemSettingSection) {
    history.replace('/settings');
  } else if (previousRoute) {
    try {
      const { path, state } = previousRoute;
      history.push(path, state);
      window.SessionStorage.removeItem('systemSettingsFrom');
    } catch (e) {
      console.log(e);
    }
  } else {
    history.push('/projects/list');
  }
}

function getProjectInfoFromLocation(location) {
  const searchParams = new URLSearchParams(
    (location || window.location).search,
  );
  const pathname = (location || window.location).pathname;
  const isProjectHome = pathname.includes('project-detail');
  const projectIdFromSearchParam =
    searchParams.get('projectId') || searchParams.get('currentId');
  const projectIdFromProjectHomePath = pathname.split('/').pop();
  const projectId = isProjectHome
    ? projectIdFromProjectHomePath
    : projectIdFromSearchParam;

  return { projectId };
}

const setURLSearchParam = (history, obj) => {
  // the history arguments is from react router
  if (!history || !obj) {
    return;
  }
  const searchParam = new URLSearchParams(history.location.search);
  Object.entries(obj).forEach(([key, value]) => {
    searchParam.set(key, value);
  });
  history.replace({
    // ...history.location,
    // pathname: history.location.pathname,
    search: searchParam.toString(),
  });
  // history.replace(history.location.pathname + '?' + searchParam.toString())
};

const removeValueFromSearchParam = (history, keys = []) => {
  if (!history || !keys?.length) {
    return;
  }
  const searchParam = new URLSearchParams(history.location.search);
  keys.forEach((key) => {
    searchParam.delete(key);
  });
  history.replace({
    ...history.location,
    search: searchParam.toString(),
  });
};

const getValueFromSearchParam = (...keys) => {
  const searchParam = new URLSearchParams(window.location.search);
  return keys.reduce((result, current) => {
    result[current] = searchParam.get(current);
    return result;
  }, {});
};

const getCustomizedModuleIdentifier = () => {
  const { integrationModuleId, from, moduleValue } = getValueFromSearchParam(
    'integrationModuleId',
    'from',
    'moduleValue',
  );
  return from === 'tiles' ? integrationModuleId : moduleValue;
};

const getAnalysisIdentifier = () => {
  const pathname = window.location.pathname;
  if (pathname.includes('analysis')) {
    const pathSegments = pathname.split('/');
    return pathSegments[pathSegments.length - 1];
  }
  return null;
};

export {
  initRouter,
  naviTo,
  checkLogin,
  handleNameInitialsModuleBack,
  getProjectInfoFromLocation,
  setURLSearchParam,
  getValueFromSearchParam,
  removeValueFromSearchParam,
  getCustomizedModuleIdentifier,
  getAnalysisIdentifier,
};
